<template>
<ItpFormSelect
  :name="name || path"
  v-model="item[path]"
  :options="currencies"
  valueField="code"
  textField="code"
  :readonly="readonly"
  @input="evh_7315092382398562_input($event, {})"
>
</ItpFormSelect>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class CurrencySelector extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    required: true,
    type: String,
  })
  path!: string;

  @Watch('path')
  onPath(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("path")
  }

  @Prop({
    type: String,
  })
  name!: string;

  @Watch('name')
  onName(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("name")
  }

  @Prop({
    type: String,
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  currencies!: any;

  async $$load_currencies() {
    return this.$app.repo.get('list_currency')
  }

  ux!: any;
  dataMembers = ['currencies', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        currencies: null,
        ux: null,
      },
    }
  }

  async act_7315092382398562_emit_7666_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7315092382398562_emit_7666, alias=undefined
    return {
      event: "input",
      value: $event,
    }
  }

  async evh_7315092382398562_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_input.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_emit_7666: actions.EmitAction;
    evh_7315092382398562_input_7665: actions.EventHandlerImpl;
    evh_7315092382398562_input: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_emit_7666 = new actions.EmitAction(
      {
        actionArgs: this.act_7315092382398562_emit_7666_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_input_7665 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_emit_7666,
        event: "input",
        displayName: "emit",
      }
    );
    const evh_7315092382398562_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_input_7665],
      }
    );
    return {
      act_7315092382398562_emit_7666,
      evh_7315092382398562_input_7665,
      evh_7315092382398562_input,
    }
  }
}

Vue.component("CurrencySelector", CurrencySelector);

</script>